export const GET_OBSERVATION_PROFILE = "GET_OBSERVATION_PROFILE";
export const GET_OBSERVATION_REVIEWERS = "GET_OBSERVATION_REVIEWERS";
export const RESET_OBSERVATION_PROFILE = "RESET_OBSERVATION_PROFILE";

// Loading action types
export const START_LOADING_OBSERVATION = "START_LOADING_OBSERVATION";
export const STOP_LOADING_OBSERVATION = "STOP_LOADING_OBSERVATION";

export const SWITCH_TO_LOCAL_TIME_ZONE = "SWITCH_TO_LOCAL_TIME_ZONE";
